
export const HOVER_THRESHOLD = 0.25;
export const MAP_DEFAULT_ATTRS = {
    zoom: 0,
    center: [0,0],
    projection: 'mercator',
    style: 'mapbox://styles/mapbox/standard',
    bounds: null
};
// Following keys need remove/filter out before map to map attributes
export const REMOVE_LAYER_KEYS = ['useJson', 'useColorJson', 'useTextFieldJson', 'useRadiusJson', 'layerName', 'layerGroup', 'layerDefault']
export const REMOVE_SOURCE_KEYS = ['tiles']
export const REMOVE_ANIMATION_KEYS = ['animationName']
export const REMOVE_MAP_KEYS = ['initial_coord', 'bounds_ne', 'bounds_sw', 'advancedSetting']
export const FORMAT_COORDINATES = ['center', 'bounds_ne', 'bounds_sw', 'initial_coord']
export const CUSTOM_LAYER_KEYS = ["info1", "info2", "info3", "fa-right", "fa-left1", "fa-left2"]
export const DEFAULT_CUSTOM_LAYER_STEP = ["step",["get", "point_count"],30,20,30,50,30,100,30]
export const MARKERS = {
    cleanCooking: 'CleanCooking',
    miniGrid: 'MiniGrid',
    solarHome: 'SolarHome'
}

export const MARKER_STATUS = {
    offline: 'offline',
    online: 'online',
    error: 'alert'
}

// Max size by pixel
export const FONT_MAPPING = {
    rightInfo: 7.1, //fontSize 10
    middleInfo: 10, // fontSize 14
}